const localHosts = new Set(['localhost', '127.0.0.1', '::1']);

export function localAcceptanceEnabled(
  hostname = typeof window === 'undefined' ? '' : window.location.hostname,
  enabled = import.meta.env.VITE_LOCAL_ACCEPTANCE_AUTH === 'true',
): boolean {
  return import.meta.env.DEV && enabled && localHosts.has(hostname);
}
